import { render, staticRenderFns } from "./SetApprovers_Form.vue?vue&type=template&id=1d5ba6df&scoped=true"
import script from "./SetApprovers_Form.vue?vue&type=script&lang=js"
export * from "./SetApprovers_Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5ba6df",
  null
  
)

export default component.exports